import { apiRequest } from "@core/services/api/apiRequest";
import { VIDEO_API } from "../videoMeeting.constants";
import type { LeaveVideoRoomResponse } from "../videoMeeting.types";

export const leaveVideoMeeting = async (
  roomId: number,
  chimeExternalUserId?: string | null
): Promise<LeaveVideoRoomResponse> => {
  return apiRequest(VIDEO_API.LEAVE_ROOM, "POST", {
    room_id: roomId,
    ...(chimeExternalUserId ? { chime_external_user_id: chimeExternalUserId } : {}),
  });
};
